import { render, staticRenderFns } from "./MembersNew.vue?vue&type=template&id=23d0b0a0"
import script from "./MembersNew.vue?vue&type=script&lang=js"
export * from "./MembersNew.vue?vue&type=script&lang=js"
import style0 from "./MembersNew.vue?vue&type=style&index=0&id=23d0b0a0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports